import {Directive, ElementRef, HostBinding, Input} from '@angular/core'
//import {RouteNames} from './app-routing.module'

@Directive({
  selector: '[appLinkName]'
})
export class LinkNameDirective {

  @Input() appLinkName: string;
  @HostBinding() href!: string;

  constructor () { }

  ngOnInit() {
    let a = this.appLinkName;
    let b = this.parseParams(a);
    //let route = RouteNames[b.routeName];

    this.href = a;
  }

  /**
   * Was hoping to find an existing library to at least handle the parsing of params, but so far nothing with TypeScript
   * support.
   *
   * @param ref
   */
  parseParams(ref: string) {
    let parsed;
    const paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
    if (paramsOnly) ref = '(' + paramsOnly[1] + ')';

    parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");

    let paramExpr = parsed[3] || null
    let params = {};
    if(parsed[3]) {
      let paramList = paramExpr.replace('{', '').replace('}', '');
      paramList = paramList.split(',');
      for(let i=0; i<paramList.length; i++) {
        let kv = paramList[i].split(':');
        let key = kv[0].trim();
        params[key] = kv[1].trim().replace(/\'/g,'');
      }
    }

    return {
      routeName: parsed[1] || null,
      params: params
    };
  }

}
